const state = {
    checkoutData: {},
    parkingData: {},
}

const getters = {    
    getCheckoutData: (state) => (parkingId) => state.checkoutData[parkingId],
    getParkingData: (state) => (parkingId) => state.parkingData[parkingId],
}

const actions = {

    async SetCheckoutData({ commit }, { checkoutData, parkingId} ) {
        commit('setCheckoutData', { checkoutData, parkingId })
    },

    async SetParkingData({ commit }, { parkingData, parkingId }) {
        commit('setParkingData', { parkingData, parkingId })
    },

}

const mutations = {
    setCheckoutData(state, {checkoutData, parkingId}) {
        state.checkoutData[parkingId] = checkoutData
    },
    setParkingData(state, {parkingData, parkingId}) {
        state.parkingData[parkingId] = parkingData
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
